import React from "react";
import { Box, Typography } from "@mui/material";
import Layout from "../layout/Layout";
import TenantList from "../pages/tenant/TenantList";

const TenantContainer = () => {
  return (
    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
      <Typography
        variant="h3"
        sx={{ mb: 1, fontWeight: "bold", color: "#333" }}
      >
        Welcome to Tenants
      </Typography>
      <Typography variant="h6" sx={{ mb: 8, color: "#666" }}>
        Here you can manage your Tenants and gain tabular information to your
        inventory.
      </Typography>
      <TenantList />
    </Box>
  );
};

export default TenantContainer;
